module.exports = [{
		id1: 1,
		num: "1",
		icon: "el-icon-s-custom",
		name1: "老人管理",
		children: [{
			path: "/",
			name: "老人数据列表"
		}]
	},
	{
		id1: 2,
		num: "2",
		icon: "el-icon-s-data",
		name1: "数据管理",
		children: [{
			path: "/health-list",
			name: "健康数据列表"
		}, {
			path: "/bed-list",
			name: "床位设备列表"
		}, {
			path: "/position-list",
			name: "定位数据列表"
		}]
	},
	{
		id1: 3,
		num: "3",
		icon: "el-icon-setting",
		name1: "平台管理",
		children: [{
			path: "/plat-list",
			name: "平台列表"
		},{
			path: "/device-bind",
			name: "设备绑定列表"
		}]
	},
	{
		id1: 4,
		num: "4",
		icon: "el-icon-user-solid",
		name1: "用户管理",
		children: [{
			path: "/user-list",
			name: "用户列表"
		}]
	},
	{
		id1: 5,
		num: "5",
		icon: "el-icon-notebook-1",
		name1: "日志管理",
		children: [{
			path: "/daily-list",
			name: "日志列表"
		}]
	},
	{
		id1: 6,
		num: "6",
		icon: "el-icon-document",
		name1: "接口文档",
		children: [{
			path: "/gain-token",
			name: "获取token"
		}, {
			path: "/add-older",
			name: "添加老人"
		}, {
			path: "/add-oldPosition",
			name: "添加老人定位数据"
		}, {
			path: "/add-surveyData",
			name: "添加监测数据"
		}]
	}, {
		id1: 7,
		num: "7",
		icon: "el-icon-set-up",
		name1: "科医智能网关",
		children: [{
			path: "/kyk-push",
			name: "科医智能网关列表"
		}]
	}, {
		id1: 8,
		num: "8",
		icon: "el-icon-aim",
		name1: "检测列表",
		children: [{
			path: "/monitor",
			name: "设备监测数据"
		}]
	}, {
		id1: 9,
		num: "9",
		icon: "el-icon-suitcase-1",
		name1: "表单设计",
		children: [{
			path: "/admin",
			name: "服务人员"
		},{
			path: "/diction-list",
			name: "字典数据"
		},{
			path: "/form-data",
			name: "模板列表"
		},{
			path: "/form-list",
			name: "表单列表"
		}]
	}
]
